import React, { useContext } from 'react';
import styles from './index.module.scss';
import { flowIdContext } from '../..';
import { Empty } from '@maxtropy/components';
import { ShareDataWrapperContext } from '@/pages/WgqAllMaps';
import classNames from 'classnames';
export interface DataCardProps {
  id: number;
  name: string;
  entryData?: number;
  lossData?: number;
  lossPercentage?: number;
  exitData?: number;
  unitName?: string;
}

const formatValue = (value: number | null | undefined, unit?: string) => {
  if (value === null || value === undefined) return '-';

  // m³ 超过 10000 显示为 万m³
  if (unit === 'm³' && Math.abs(value) >= 10000) {
    return `${(value / 10000).toFixed(1)}万m³`;
  }

  if (unit === '%') {
    return `${value.toFixed(1)}%`;
  }

  const valueText = Number.isInteger(value) ? `${value}` : value.toFixed(1);
  return `${valueText}${unit ?? ''}`;
};

const Card: React.FC<DataCardProps & { isSelected: boolean; onClick: () => void; cardNumber: number }> = ({
  name,
  lossPercentage,
  isSelected,
  onClick,
  cardNumber,
}) => {
  return (
    <div className={`${styles.dataCard} ${isSelected ? styles.selected : ''}`} onClick={onClick}>
      <div className={styles.rankArea}>
        <span className={styles.cardNumber}>{cardNumber}</span>
        <span className={styles.cardTitle} title={name}>
          {name}
        </span>
      </div>
      <div className={styles.dataItem}>
        <span className={styles.label}>偏差率：</span>
        <span className={`${styles.value} ${styles.lossValue}`}>{formatValue(lossPercentage, '%')}</span>
      </div>
      <div className={styles.lightLine} />
    </div>
  );
};

const DataCard: React.FC<{ data: DataCardProps[] }> = ({ data }) => {
  const { setNodeTitle, setNodeId, nodeId } = useContext(flowIdContext);
  const { isStandardSize, loadMap } = useContext(ShareDataWrapperContext);
  const isLargeNoMapLayout = !isStandardSize && !loadMap;
  const isStandardNoMapLayout = isStandardSize && !loadMap;

  return (
    <div
      className={classNames(
        styles.cardsContainer,
        isLargeNoMapLayout ? styles.cardsContainerLargeNoMap : '',
        isStandardNoMapLayout ? styles.cardsContainerStandardNoMap : ''
      )}
    >
      {data.length === 0 ? (
        <div className={styles.emptyWrapper}>
          <Empty description="暂无数据" />
        </div>
      ) : (
        data.map((data, index) => (
          <Card
            key={data.id}
            {...data}
            cardNumber={index + 1}
            isSelected={nodeId === data.id}
            onClick={() => {
              setNodeId(data.id);
              setNodeTitle(data.name);
            }}
          />
        ))
      )}
    </div>
  );
};
export default DataCard;
